<template>
  <div class="hours-container">
    <span v-for="item in 24" :key="item" class="time-grid-item"> {{ item - 1 }}:00 </span>
    <div class="work-time" :style="workTimeStyle" />
  </div>
</template>

<script lang="ts">
import { Temporal } from '@js-temporal/polyfill'
import { TIME_LINE_HOUR_WIDTH } from '@/src/lib/constants'

export default defineComponent({
  props: {
    startTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const workTimeStyle = computed<Record<'left' | 'width', string>>(() => {
      const workStartTime = Temporal.PlainTime.from(props.startTime)
      const workEndTime = Temporal.PlainTime.from(props.endTime)
      const workStartTimeMinutes = workStartTime
        .with({ hour: 0, minute: 0 })
        .until(workStartTime)
        .total({ unit: 'minute' })
      const workMinutes = workStartTime.until(workEndTime).total({ unit: 'minute' })

      return {
        left: `${(TIME_LINE_HOUR_WIDTH * workStartTimeMinutes) / 60}px`,
        width: `${(TIME_LINE_HOUR_WIDTH * workMinutes) / 60}px`,
      }
    })

    return { workTimeStyle }
  },
})
</script>

<style lang="scss" scoped>
@use '@/stylesheets/application/resources';

.hours-container {
  background-color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid resources.$border;
  height: 40px;
  overflow: hidden;
  position: sticky;
  top: 0;
  z-index: 4;
}

.time-grid-item {
  color: resources.$grey-darker;
  display: block;
  float: left;
  font-size: 16px;
  margin-top: 12px;
  transform: translateX(-12px);
  width: resources.$app-timeline-hour-width;
}

.work-time {
  background-color: #ffbd51;
  display: block;
  height: 5px;
  left: 400px;
  position: absolute;
  width: 450px;
}
</style>
